module.exports = __webpack_public_path__ + "96d1675e9e91c4692e54b6c56486b385.pdf";